import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class StateService {

  pageLoading$ = new BehaviorSubject<boolean>(false);

  constructor() { }
}
